import React from 'react';

import { slugify } from '../../../../utils/slugify';
import CountySelect from '../../../input/CountySelect';

// Import slugify function

function CountyGolfCoursesHeader({ onChange, value, selectedCountySlug }) {
  const handleCountySelectChange = (selectedOption) => {
    //console.log(selectedOption);
    if (selectedOption && selectedOption.label) {
      onChange(slugify(selectedOption.label)); // Pass the slugified value
    }
  };

  return (
    <div className="mx-auto my-2">
      <div className="w-11/12 mx-auto rounded-md">
        <div className="mx-auto flex flex-col justify-center flex-nowrap sm:flex-row sm:flex-wrap">
          <div className="w-full grid grid-cols-1 z-40">
            <CountySelect onChange={handleCountySelectChange} value={value} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CountyGolfCoursesHeader;
